'use client'

import {shallow} from 'zustand/shallow'
import {useShopifyStore} from './useShopifyStore'

export const useIsMember = () => {
	return useShopifyStore(state => state.customer?.tags.includes('Active Subscriber'), shallow)
}
